"use strict";
/**
 * Order Calculations
 * Financial calculations for orders and positions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateOrderCost = estimateOrderCost;
exports.calculatePnL = calculatePnL;
/**
 * Get estimated cost of order
 * @param quantity - Number of contracts
 * @param priceLimit - Price per contract
 * @returns Total cost
 */
function estimateOrderCost(quantity, priceLimit) {
    return quantity * priceLimit;
}
/**
 * Calculate potential profit/loss
 * @param entryPrice - Entry price per contract
 * @param exitPrice - Exit price per contract
 * @param quantity - Number of contracts
 * @param side - yes or no position
 * @returns Profit or loss amount
 */
function calculatePnL(entryPrice, exitPrice, quantity, side) {
    if (side === "yes") {
        // Long position: profit when price goes up
        return (exitPrice - entryPrice) * quantity;
    }
    else {
        // Short position: profit when price goes down
        return (entryPrice - exitPrice) * quantity;
    }
}
